export default [
  {
    description:
      'check.vehicles.machinery.passed.itv.corresponding.inspections.ce.marking',
    responsible: 2,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'correct.itv.inspections.ce.marking',
  },
  {
    description: 'check.good.ventilation.substances.works.produce.gases.smoke',
    responsible: 2,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'good.ventilation',
  },
  {
    description:
      'check.periodic.irrigation.weather.demolished.excavated.roads.tracks',
    responsible: 2,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.large.quantities.of.dust.are.generated',
  },
  {
    description: 'check.speed.limits.inside.worksite',
    responsible: 2,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'signage.placed.respected',
  },
  {
    description:
      'avoid.possible.earthworks.dusty.material.movements.strong.wind.conditions',
    responsible: 2,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'not.carried.out.conditions',
  },
  {
    description: 'check.wind.erosion.anticipated.stockpiles.dusty.materials',
    responsible: 2,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'placement.tarpaulins.windbreak.barriers',
  },
  {
    description: 'check.vehicles.protective.measures.prevent.loss.dust',
    responsible: 2,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection:
      '100.percent.availability.vehicles.traveling.outside.worksite',
  },
  {
    description: 'check.established.schedules.execution.work.met',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'schedule.compliance.default.hours',
  },
  {
    description:
      'check.vehicles.machinery.passed.itv.corresponding.inspections.ce.marking',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'correct.itv.inspections.ce.marking',
  },
  {
    description:
      'check.pit.level.authorized.transporter.chemical.services.invoice',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'emptying.authorized.transporter',
  },
  {
    description:
      'washing.concrete.tanks.channels.marking.signage.conditioning.washing.areas',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'washing.only.established.areas',
  },
  {
    description:
      'check.measures.taken.prevent.washes.stockpiled.aggregates.rain.irrigation',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection:
      'check.taken.washes.stockpiled.rain.crushing.plants.washing.irrigation',
  },
  {
    description: 'register.fuel.consumption.during.execution.work',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'register.electricity.consumption.during.execution.work',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'register.water.consumption.during.execution.work',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'record.technical.gas.consumption.during.construction',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'record.natural.gas.consumption.during.construction',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'check.signaling.adaptation.waste.storage.areas.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.signage.adaptation',
  },
  {
    description: 'check.correct.waste.segregation',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'not.mixed',
  },
  {
    description:
      'check.authorizations.contract.documentation.management.carriers.managers.landfills',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 2,
    acceptanceRejection: 'appropriate.and.registered.documentation',
  },
  {
    description: 'storage.period',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'identified.start.storage.which.less.6.months.rp',
  },
  {
    description:
      'check.stockpiles.large.volumes.materials.not.made.sensitive.areas',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'preliminary.study.before.starting.stockpiles',
  },
  {
    description: 'consideration.impact.road.rail.pedestrian.traffic',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection:
      'coordination.works.minimize.impact.on.traffic.ensure.pedestrian.access',
  },
  {
    description: 'check.order.cleanliness.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'good.conditions.order.cleanliness',
  },
  {
    description:
      'check.order.cleanliness.influence.area.work.cleaning.public.road',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'good.conditions.order.cleanliness',
  },
  {
    description:
      'check.construction.influence.cleaning.and.order',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'good.conditions.order.cleanliness',
  },
];
